<template>
  <div class="decision-aid">
    <div class="heading">
      <span class="title">{{ $t('hose.helpTool.title') }}</span>
    </div>
    <span class="close-btn" @click="$emit('close')">&times;</span>

    <table class="decision-table">
      <tr>
        <th
            v-for="th in aidHeaders"
            v-text="th"
        ></th>
      </tr>
      <tr v-for="(row) in aidRows" @click="setHose(row)">
        <td v-for="val in row" v-text="val"></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "DecisionAid",

  data() {
    return {
      aidHeaders: [
        this.$t('hose.helpTool.measurement'),
        this.$t('hose.helpTool.innerDiameter'),
        this.$t('hose.helpTool.pressureLine'),
        this.$t('hose.helpTool.returnLine'),
        this.$t('hose.helpTool.suctionLine'),
        this.$t('hose.helpTool.oneLayer'),
        this.$t('hose.helpTool.twoLayer'),
        this.$t('hose.helpTool.fourLayer')
      ],
      aidRows: [
        ['1/4"', 6.3, 13, 7, 4, 225, 400, 450],
        ['5/16"', 8.2, 20, 10, 6, 215, 350, '-'],
        ['3/8"', 9.8, 30, 14, 8, 180, 330, 445],
        ['1/2"', 12.9, 50, 25, 13, 160, 275, 415],
        ['5/8"', 16.2, 75, 40, 20, 130, 250, 350],
        ['3/4"', 19.2, 105, 55, 30, 105, 215, 350],
        ['1"', 25.3, 190, 95, 50, 88, 165, 280],
        ['1 1/4"', 32.3, 300, 150, 80, 63, 125, 210],
        ['1 1/2"', 38.2, 415, 210, 110, 50, 90, 185],
        ['2"', 51, 740, 370, 200, 40, 80, 165],
      ],
    }
  },

  methods: {
    setHose(row) {
      this.$emit('clickedHoseRow', row[2]);
      this.$emit('close');
    }
  }
}
</script>

<style scoped lang="scss">
.decision-aid {

  .heading {
    padding: 20px 19px;
    position: relative;

    .title {
      font-size: 20px;
      font-family: neue-haas-grotesk-display, sans-serif;
    }
  }

  .close-btn {
    color: #A4AFB7;
    position: absolute;
    font-size: 30px;
    right: 12px;
    top: 0;
    cursor: pointer;
    transition: all ease 0.3s;

    &:hover {
      color: darken(#A4AFB7, 40%);
    }
  }

  .decision-table {
    margin-top: 10px;
    border-collapse: separate;
    border-spacing: 3px 0;
    background-color: #F0F0F0;

    th, td {
      &:nth-child(2) {
        border-collapse: unset;
        border-spacing: unset;
        border-right: #AFAFAF 4px solid;
      }
      &:nth-child(5) {
        border-collapse: unset;
        border-spacing: unset;
        border-right: #AFAFAF 4px solid;
      }
    }

    th {
      text-align: center;
      background-color: white;
      font-size: 12px;
      font-family: neue-haas-grotesk-display, sans-serif;
      font-weight: 700;
      cursor: default;
    }

    td {
      font-size: 12px;
      border-spacing: 4px;
      padding: 8px 10px;
      text-align: center;

      &:hover {
        color: white;
        background-color: rgba(61, 176, 199, 0.5);
      }
    }

    tr {
      cursor: pointer;

      &:nth-child(even) {
        background-color: white;

        &:hover {
          background-color: rgba(61, 176, 199, 0.25);

          > td:nth-child(1), td:nth-child(2) {
            color: white;
            background-color: rgba(61, 176, 199, 0.5);
          }
        }
      }

      &:nth-child(odd) {
        background-color: #EBEBEB;

        &:hover {
          background-color: rgba(61, 176, 199, 0.25);

          > td:nth-child(1), td:nth-child(2) {
            color: white;
            background-color: rgba(61, 176, 199, 0.5);
          }
        }
      }

      .selected {
        background-color: #3DB0C7;
      }
    }
  }
}
</style>